export const DIRECT_EEG_UPLOAD_THRESHOLD_BYTES = 100 * 1024 * 1024;
export const PATIENT_METADATA_MISMATCH_CODE = "PATIENT_METADATA_MISMATCH";
